import Select from 'react-select';
import styles from './styles.module.css';
import {useTranslation} from 'next-i18next';

const OrderFilter = ({
  onSelect,
  value,
}: {
  onSelect: (newValue: any) => void;
  value: unknown;
}) => {
  const {t} = useTranslation('customer-orders');

  const options = [
    {value: 'paid', label: t('filters.paid_orders')},
    {value: 'waiting_for_payment', label: t('filters.waiting_for_payment')},
    {
      value: 'waiting_to_be_synchronized',
      label: t('filters.waiting_to_be_synchronized'),
    },
    {value: 'synchronized', label: t('filters.synchronized')},
  ];
  return (
    <div className={styles.filter}>
      <span>{t<string>('filters.title')}</span>
      <div className={styles.filterSelect}>
        <Select
          onChange={onSelect}
          defaultValue={value}
          isMulti={false}
          value={value}
          placeholder={t<string>('filters.all_orders')}
          className={'ole'}
          classNamePrefix="select"
          isSearchable={false}
          name="color"
          options={options}
        />
      </div>
    </div>
  );
};

export default OrderFilter;
